<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">제품주문</h1>
      <BreadCrumb :breadcrumbs="breadcrumbItems" />
    </div>

    <div class="l-content">
      <SearchKeyword
        v-model:keyword="keyword"
        v-model:keyword2="keyword2"
        v-model:keyword3="keyword3"
        @keyword-changed="onSearchKeywordChange"
      />

      <!-- D: 제품주문 페이지 -->
      <div class="p-order-wrap" v-if="!isNodata && searchCategories">
        <ProdCategory
          v-if="searchCategories && salesBranch"
          v-model:searchCategories="searchCategories"
          :sales-branch="salesBranch"
          :search-Params="searchParams"
          @select-changed="onSearchCategoriesChange"
        />

        <!-- D: 새로고침 -->
        <div v-if="!noSearchParamYn" class="c-btn-area has-center">
          <button
            type="button"
            class="c-button type-primary"
            style="--btn-width: 200px"
            @click="resetSearch"
          >
            <span>새로고침</span>
          </button>
        </div>

        <!-- D: total&sorting -->
        <div class="c-sorting-wrap">
          <em v-if="pageData" class="total">
            총:
            <span class="system">
              {{ Utils.currency(pageData.totalCount) }}
            </span>
            개
          </em>
          <!-- D: pc 전용 -->
          <ul class="sorting c-pc">
            <li class="sorting-item">
              <!-- D: 클릭시 is-current 클래스 추가 -->
              <a
                href="#"
                :class="{
                  'is-current': searchParams.sortOrder === 'recommend',
                }"
                @click.prevent="onSortChange('recommend')"
                >추천순</a
              >
            </li>
            <li class="sorting-item">
              <a
                href="#"
                :class="{ 'is-current': searchParams.sortOrder === 'populate' }"
                @click.prevent="onSortChange('populate')"
                >인기순</a
              >
            </li>
            <li class="sorting-item">
              <a
                href="#"
                :class="{ 'is-current': searchParams.sortOrder === 'register' }"
                @click.prevent="onSortChange('register')"
                >신제품순</a
              >
            </li>
          </ul>

          <!-- D: MO 전용 -->
          <div class="c-select type-medium c-mo">
            <select
              v-model="searchParams.sortOrder"
              @change="onSortChange(searchParams.sortOrder)"
            >
              <option value="recommend">추천순</option>
              <option value="populate">인기순</option>
              <option value="register">신제품순</option>
            </select>
          </div>
        </div>

        <!-- D: product compentnt -->
        <div v-if="pageData" class="c-products">
          <!-- 상단 메뉴 -->
          <div class="top-menu" v-if="!isMobile">
            <!-- <div class="menu-item menu-item-1">이미지</div> -->
            <div class="menu-item menu-item-2">분류</div>
            <div class="menu-item menu-item-3" style="width:15%">상세정보</div>
            <div class="menu-item menu-item-4">가격</div>
            <div class="menu-item menu-item-5"></div>
          </div>
          <div class="scroll-x only-pc-widh">
            <div class="scroll-x scroll-x-inner">
              <ProductItem
                v-for="item in list"
                :key="item.matnr"
                :product="item"
                :werks="CODE_WERKS"
                @buy="(product) => orderSheet.addItemList(product)"
                @cart="(product) => addCartItem(product)"
                @select="openProdInfoPop"
              />
            </div>
          </div>
        </div>

        <!-- D: MO전용 장바구니 담기 토스트 -->
        <!-- 2024-12-20 케이스 추가 -->
        <div class="c-toast-black has-mo" data-toast="moBasket">
          <span class="text">장바구니에 담겼습니다</span>
          <!-- CASE:
            <span class="text">주문서에 담겼습니다</span>
    <span class="text">이미 장바구니에 담은 제품입니다.</span>
          -->
        </div>
        <!-- // D: MO전용 장바구니 담기 토스트 -->
      </div>
      <div v-if="isNodata" class="p-order-wrap">
        <!-- D: no-data -->
        <div class="c-no-data-box">
          <div class="icon-box">
            <i class="c-icon icon-nodata size-large"></i>
          </div>
          <div class="text">
            <p>
              해당 검색어로 검색된 결과가 <br class="only-mo" />존재하지
              않습니다.
            </p>
            <p class="sub-text">검색어가 올바르게 입력되었는지 확인해주세요.</p>
          </div>
        </div>

        <!-- D: 새로고침 -->
        <div v-if="!noSearchParamYn" class="c-btn-area has-center">
          <button
            type="button"
            class="c-button type-primary"
            style="--btn-width: 200px"
            @click="resetSearch"
          >
            <span>새로고침</span>
          </button>
        </div>
      </div>
    </div>

    <OrderSheet ref="orderSheet" @select="openProdInfoPop" />

    <QuickMenu />
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <DeliveryRegPop v-if="isModalVisible2" />
  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
  <OrderOnboardPop
    v-if="isShowOrderOnboardPop"
    @close="() => (isShowOrderOnboardPop = false)"
  />
</template>
<script setup>
import {
  ref,
  onMounted,
  onBeforeUnmount,
  inject,
  provide,
  readonly,
  computed,
  watch,
  nextTick,
} from "vue";
import SearchKeyword from "@/components/paintpro/prod/searchProdKeyword.vue";
import ProdCategory from "@/components/paintpro/prod/prodCategory.vue";
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import ProductItem from "@/components/paintpro/prod/searchProductItemSub.vue";
import DeliveryRegPop from "@/components/paintpro/prod/deliveryRegPop.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import OrderOnboardPop from "@/components/paintpro/utility/orderOnBoardLayer.vue";

import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import * as cmApi from "@/api/cmApi";
import OrderSheet from "@/components/paintpro/prod/orderSheet.vue";
// import { getPageInitData } from "@/api/common/commonApi";
import * as store from "@/store";
import { useAuthStore } from "@/store";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
const authStore = useAuthStore();
const url = inject("url_prefix");
const isModalVisible2 = false;

const orderSheet = ref();

const breadcrumbItems = ref([{ name: "제품주문", path: "/paintpro/prodList" }]);

const keyword = ref("");
const keyword2 = ref("");
const keyword3 = ref("");

const searchParams = ref({});

const searchCategories = ref(null);
const pageData = ref(null);
const list = ref([]);

const isShowProdInfoPop = ref(false);
const isShowOrderOnboardPop = ref(false);

const onLoadSearchDataYn = ref(false);

const prodInfoPopProps = ref({
  matnr: null,
});

const CODE_WERKS = ref([]);
provide("CODE_WERKS", readonly(CODE_WERKS));

const CODE_GOODS_FILE_SE_CD = ref([]);
provide("CODE_GOODS_FILE_SE_CD", readonly(CODE_GOODS_FILE_SE_CD));

const scrollSensed = ref(false); // 스크롤 중복 감지를 막기 위한 변수입니다.

const isNodata = ref(false);

onMounted(async () => {
  await initPage();

  loadSearchCategories();
  loadSearchData();

  window.addEventListener("scroll", onScrollEvent, true);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScrollEvent);
});

const salesBranch = computed(() => {
  return authStore.user?.empList[store.useEventBusStore()?.salesPersonIndex];
});

watch(salesBranch, () => {
  resetPage();
  loadSearchData();
});

const noSearchParamYn = computed(() => {
  // 검색 조건 상태가 초기 상태인지 여부를 판단합니다.
  return (
    searchParams.value.keyword === "" &&
    searchParams.value.keyword2 === "" &&
    searchParams.value.keyword3 === "" &&
    searchParams.value.lvl2Categories.length === 0 &&
    searchParams.value.lvl3Categories.length === 0 &&
    searchParams.value.lvl4Categories.length === 0
  );
});

const initPage = async () => {
  const res = await cmApi.getPageInitData([
    { qId: "cmCode_code1", parm: { cdGrp: "WERKS" } },
    { qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } },
  ]);

  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }
  CODE_WERKS.value = res.data.cmCode_code1;
  CODE_GOODS_FILE_SE_CD.value = res.data.cmCode_code2;

  if (
    cmUtil.getToday().indexOf("202504") > -1 ||
    cmUtil.getToday().indexOf("202505") > -1
  ) {
    if (
      cmUtil.getLocalStorage("gv.orderOnBoardLayer.hiddenDate") !==
      cmUtil.getToday()
    ) {
      if (res.data?.userLoginInfo?.orderManualIdntyYn === "N") {
        isShowOrderOnboardPop.value = true;
      }
    }
  } else {
    if (res.data?.userLoginInfo?.orderManualIdntyYn === "N") {
      cmApi.updateUserPersonInfo({
        type: "orderManualIdntyYn",
      });
      isShowOrderOnboardPop.value = true;
    }
  }
};

const initSearchParams = () => {
  searchParams.value = {
    keyword: "",
    keyword2: "",
    keyword3: "",
    lvl2Categories: [],
    lvl3Categories: [],
    lvl4Categories: [],

    matkl: "", // 영업사원 담당분야

    page: 1,
    limit: 20,

    sortOrder: "recommend", // recommend: 추천순, populate:인기순, register:신제품순
  };

  keyword.value = "";
  keyword2.value = "";
  keyword3.value = "";
};
initSearchParams();

const resetSearch = () => {
  initSearchParams();
  searchCategories.value = null;
  loadSearchCategories();
  loadSearchData();
};

const openProdInfoPop = (product) => {
  prodInfoPopProps.value.matnr = product.matnr;
  isShowProdInfoPop.value = true;
};

const loadSearchCategories = async () => {

  const res = await api.post(`${url}/product/search-categories`, {
    keyword: keyword.value.trim(),
    keyword2: keyword2.value.trim(),
    keyword3: keyword3.value.trim(),
    clsfCdListLvl2 : searchParams.value.lvl2Categories,
    clsfCdListLvl3 : searchParams.value.lvl3Categories
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  if(searchCategories.value==null){
    searchCategories.value = res.data;
  }else{
    searchCategories.value.lvl2Categories = res.data.lvl2Categories;
    searchCategories.value.lvl3Categories = res.data.lvl3Categories;
    searchCategories.value.lvl4Categories = res.data.lvl4Categories;
    searchCategories.value.topCategories = res.data.topCategories;
  }

  for(var lvl2i=0; lvl2i<searchParams.value.lvl2Categories.length; lvl2i++){
    for(var lvl2ii=0; lvl2ii<searchCategories.value.lvl2Categories.length; lvl2ii++){
      if(searchParams.value.lvl2Categories[lvl2i] == searchCategories.value.lvl2Categories[lvl2ii].clsfCd){
        searchCategories.value.lvl2Categories[lvl2ii].selected = true;
      }
    }    
  }

  for(var lvl3i=0; lvl3i<searchParams.value.lvl3Categories.length; lvl3i++){
    for(var lvl3ii=0; lvl3ii<searchCategories.value.lvl3Categories.length; lvl3ii++){
      if(searchParams.value.lvl3Categories[lvl3i] == searchCategories.value.lvl3Categories[lvl3ii].clsfCd){
        searchCategories.value.lvl3Categories[lvl3ii].selected = true;
      }
    }    
  }

  for(var lvl4i=0; lvl4i<searchParams.value.lvl4Categories.length; lvl4i++){
    for(var lvl4ii=0; lvl4ii<searchCategories.value.lvl4Categories.length; lvl4ii++){
      if(searchParams.value.lvl4Categories[lvl4i] == searchCategories.value.lvl4Categories[lvl4ii].clsfCd){
        searchCategories.value.lvl4Categories[lvl4ii].selected = true;
      }
    }    
  }
  
  window.dispatchEvent(new Event('resize'));
  searchValSetting();
};

const onSearchKeywordChange = (keyword, keyword2, keyword3) => {
  searchParams.value.keyword = keyword;
  searchParams.value.keyword2 = keyword2;
  searchParams.value.keyword3 = keyword3;

  searchValSetting();

  resetPage();

  cmUtil.loading("", { duration: 60000 });

  loadSearchData();
  loadSearchCategories();
};

const onSearchCategoriesChange = async () => {
  if (!searchCategories.value) {
    searchParams.value.lvl2Categories = [];
    searchParams.value.lvl3Categories = [];
    searchParams.value.lvl4Categories = [];

    return;
  }

  searchValSetting();

  cmUtil.loading("", { duration: 60000 });
  
  loadSearchCategories();

  await resetPage();

  nextTick(() => {
    loadSearchData();
  });
};

const searchValSetting = async () => {
  searchParams.value.lvl2Categories = searchCategories.value.lvl2Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);

  searchParams.value.lvl3Categories = searchCategories.value.lvl3Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);

  searchParams.value.lvl4Categories = searchCategories.value.lvl4Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);
}

const onSortChange = (sortOrder) => {
  searchParams.value.sortOrder = sortOrder;
  resetPage();

  loadSearchData();
};

const loadSearchData = async () => {
  if (onLoadSearchDataYn.value) return;

  onLoadSearchDataYn.value = true;

  if (!authStore.user) return;

  searchParams.value.matkl = salesBranch.value.matkl; // 현재 선택된 영업사원 담당분야

  const res = await api.post(`${url}/product/search`, {
    ...searchParams.value,
  });

  
  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  cmUtil.loadingHide();

  pageData.value = res.data;
  list.value.push(...pageData.value.list);

  isNodata.value = list.value.length === 0;

  onLoadSearchDataYn.value = false;

};

const loadNextPage = () => {
  if (!pageData.value) {
    return;
  }

  if (pageData.value.currPage >= pageData.value.totalPage) {
    return;
  }

  searchParams.value.page += 1;

  loadSearchData();
};

const resetPage = async () => {
  searchParams.value.page = 1;
  list.value = []; // 리스트 초기화
};

const onScrollEvent = () => {
  const scrollTop = Math.ceil(document.documentElement.scrollTop);
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = document.documentElement.clientHeight;

  const isBottom = scrollTop + clientHeight >= scrollHeight ? true : false;

  if (isBottom) {
    loadNextPage();

    scrollSensed.value = true;
    setTimeout(() => {
      scrollSensed.value = false;
    }, 50);
  }
};

const addBuyItem = (product) => {
  orderSheet.value.addItemList(product);
};
provide("addBuyItem", addBuyItem);

const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    zzlqdCls: param.product.zzlqdCls,
    goodsQty: param.quantity,
  });
};
provide("addCartItem", addCartItem);
</script>
